import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, Alert, Row, Col, message, Select, Tabs } from 'antd';
import Ink from 'react-ink';
import { yearFrom, yearTo } from './../../../config';

import {
  occupationInsert,
  occupationUpdate,
} from '../../../modules/occupation';
import {
  schoolList
} from '../../../modules/school';

const FormItem = Form.Item;
const { Option } = Select;
const { TabPane } = Tabs;

class OccupationDetails extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
			message: null,
      schoolList: null,
      tabActiveKey: 'tc',
		}
    this.yearList = [];
    for (let i = yearFrom; i <= yearTo; i++) {
      this.yearList.push(`${i} - ${i+1}`);
    }
    this.ids = {};
    this.langs = ['tc', 'en', "sc"];
	}

  componentDidMount = () => {
    if (!this.props.schoolListData) {
      this.getSchoolList();
    } else {
      this.setState({schoolList: this.props.schoolListData});
    }
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (prevProps.data !== data) {
      this.props.form.resetFields();
      this.ids = {};
      this.setState({tabActiveKey: 'tc'});
    }
  }

  makeArray = (names, key, name, isString) => {
    return this.langs.map((lang, i) => {
      let result = { lang: lang };
      let targetKey = Object.keys(names).filter(k => k.includes(`${key}_${lang}`) && names[k] !== '').sort((a, b) => a.localeCompare(b));
      result[name] = isString ? targetKey.map(k => names[k])[0] : targetKey.map(k => names[k]);;
      return result;
    })
  }
	
  makePayload = (values) => {
    return {
      code: values.code,
      name: this.makeArray(values.names, 'name', 'name', true),
      description: this.makeArray(values.names, 'description', 'descriptions'),
      character: this.makeArray(values.names, 'character', 'characters'),
      requirement: this.makeArray(values.names, 'requirement', 'requirements'),
      career: this.makeArray(values.names, 'career', 'description', true),
      hashTag: this.makeArray(values.names, 'hashTag', 'hashTags'),
    };
  }

	handleSubmit = e => {
		e.preventDefault();

		const { data } = this.props;

		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ loading: true });

				if (!this.props.data) {
          console.log(values);
					this.props.occupationInsert(this.makePayload(values)).then( 
						(res) => {
							message.success('成功新增職業!');
							this.setState({ loading: false, message: null });
							this.props.form.resetFields();
              this.ids = {};
							this.props.callback();
						},
						(err) => {
							this.setState({ loading: false, message: `Can't get through. Please make sure input is valid or contact the administrator.` }); 
						}
					);
				}
				else {
          console.log(values);
				
          this.props.occupationUpdate(this.makePayload(values), data._id).then( 
            (res) => {
              message.success('成功編輯職業!');
              this.setState({ loading: false, message: null });
              this.props.callback();
            },
            (err) => {
              this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
            }
          );
			  }
			} else {
        this.setState({ message: `請輸入必填項目` }); 
      }
		});
	}

  getSchoolList = () => {
    this.props.schoolList().then((res) => {
      this.setState({schoolList: res});
    })
  }

  constructSchoolOptions = () => {
    const { schoolList } = this.state;
    if (schoolList) {
      return schoolList.results.map((item, i) => <Option value={item._id}>{item.name_tc || item.name_en}</Option>);
    }
  }

  constructYearOptions = () => {
    return this.yearList.map((item, i) => <Option value={item}>{item}</Option>);
  }

  getLocale = (items, lang) => {
    let result = items.filter(i => i.lang === lang);
    return result.length > 0 ? result[0] : null;
  }

  remove = (k, fieldKey) => {
    const { form } = this.props;
    // can use data-binding to get
    let keys = form.getFieldValue(fieldKey);
    if (!this.ids[`${fieldKey}`]) {
      this.ids[`${fieldKey}`] = keys.length - 1;
    }

    // We need at least one passenger
    if (keys.length === 1) {
      return;
    }

    // can use data-binding to set
    let temp = {};
    temp[fieldKey] = keys.filter(key => key !== k);
    form.setFieldsValue(temp);
  };

  add = (fieldKey) => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue(fieldKey);

    if (!this.ids[`${fieldKey}`]) {
      this.ids[`${fieldKey}`] = keys.length - 1;
    }
    this.ids[`${fieldKey}`]++;
    const nextKeys = keys.concat(`${fieldKey}-${this.ids[`${fieldKey}`]}`);
    // can use data-binding to set
    // important! notify form to detect changes
    let temp = {};
    temp[fieldKey] = nextKeys;
    form.setFieldsValue(temp);
  };

  constructFieldItems = (key, lang, label, name) => {
    const { data } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    let fieldKey = `${key}_${lang}`;
    getFieldDecorator(fieldKey, { initialValue: data && this.getLocale(data[key], lang) && this.getLocale(data[key], lang)[name].length > 0 ? Array.from(Array(this.getLocale(data[key], lang)[name].length).keys()).map(a => `${fieldKey}-${a}`) : [`${fieldKey}-0`]});
    const keys = getFieldValue(fieldKey);
    let results = keys.map((k, index) => {
      let k_num = parseInt(k.split('-')[1], 10);
      let initialValues = data && this.getLocale(data[key], lang) ? this.getLocale(data[key], lang)[name] : [];
      return (
        <FormItem
          label={index === 0 ? label : ''}
          required={false}
          key={k}
        >
          { getFieldDecorator(`names[${k}]`, {
            validateTrigger: ['onChange', 'onBlur'],
            initialValue: data && initialValues.length > k_num ? initialValues[k_num] : '',
          })(
            <Input placeholder={label} style={{ width: '60%', marginRight: 8 }}/>
          )}
          {
            keys.length > 1 ? (
              <Icon
                className="dynamic-delete-button"
                type="minus-circle-o"
                onClick={() => this.remove(k, fieldKey)}
              />
            ) : null
          }
        </FormItem>
      );
    });
    results.push(
      <FormItem>
        <Button type="dashed" onClick={() => this.add(fieldKey)} style={{ width: '60%' }}>
          <Icon type="plus" /> 增加
        </Button>
      </FormItem>
    )
    return results;
  }

  constructTabPane = () => {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;

    return this.langs.map((lang, i) => {
      return (
        <TabPane tab={lang} key={lang}>
          <Row gutter={16}>
					  <Col span={12}>
              <FormItem
                label="名稱"
              >
                { getFieldDecorator(`names[name_${lang}]`, {
                  rules: [ { required: true, message: '請輸入名稱！' } ],
                  initialValue: (data && this.getLocale(data.name, lang)) ? this.getLocale(data.name, lang).name : "",
                })(
                  <Input style={{ width: '80%' }}/>
                )}
              </FormItem>

              { this.constructFieldItems('description', lang, "工作內容", "descriptions") }

              { this.constructFieldItems('character', lang, "性格特質", "characters") }
            </Col>
            <Col span={12}>
              { this.constructFieldItems('requirement', lang, "技能要求", "requirements") }

              <FormItem
                label="升學/就業途徑"
              >
                { getFieldDecorator(`names[career_${lang}]`, {
                  initialValue: (data && this.getLocale(data.career, lang)) ? this.getLocale(data.career, lang).description : "",
                })(
                  <Input />
                )}
              </FormItem>

              { this.constructFieldItems('hashTag', lang, "Hashtag關聯詞", "hashTags") }

            </Col>
          </Row>
            
        </TabPane>
      );
    })
  }

  handleTabChange = (key) => {
    this.setState({tabActiveKey: key});
  }

	render() {
		
		const { loading, message, tabActiveKey } = this.state;
		const { getFieldDecorator } = this.props.form;

		const { data } = this.props;
		
		return (
			<Form onSubmit={this.handleSubmit} className="ownForm">
				{ (message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}

        <FormItem
					label="SDS Code"
				>
					{ getFieldDecorator('code', {
						rules: [ { required: true, message: '請輸入SDS Code！' } ],
						initialValue: (data && data.code) ? data.code : "",
					})(
					  <Input />
					)}
				</FormItem>

        <Tabs defaultActiveKey="tc" activeKey={tabActiveKey} onChange={this.handleTabChange.bind(this)}>
          {
            this.constructTabPane()
          }
        </Tabs>

				<FormItem 
					className="noMarginBtm"
				>
					<Button type="primary" htmlType="submit" disabled={loading} style={{ width: '100%' }}><Ink /><Icon type="arrow-right" /> 提交</Button>
				</FormItem>
			</Form>
		);
	}
}

const WrappedOccupationDetailsModal  = Form.create()(OccupationDetails);

const mapStateToProps = state => ({
  schoolListData: state.school.data,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		occupationInsert,
		occupationUpdate,
    schoolList,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedOccupationDetailsModal);